import $ from 'jquery';

const init = () => {
	const trigger = $('.gallery [data-gallery-trigger]');
	if(!trigger.length) { return; }

	const gallery = trigger.closest('.gallery');
	// this happens only on desktop
	trigger.on('click', (e) => {
		e.preventDefault();
		gallery.addClass('is-activated');
		
		// used on carousel
		$(document).trigger('gallery.activated');
	});

	// used on carousel
	$(document).on('gallery.inactivated', () => {
		gallery.removeClass('is-activated');
	});
};

$(document).ready(init);
